import styled from 'styled-components';
import { Offer } from '../../../../new-lib/types/entity';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';

const OfferPlan = ({ offer }: { offer: Offer }) => {
  const { locale } = useRouter();
  const { t } = useTranslation('entity');

  const getCardContent = () => {
    if (offer.cashDiscountPercentage) {
      return (
        <div className="offer-content">
          <div className="percentage-payment">
            <span>{Math.round(offer?.cashDiscountPercentage)}%</span>
            <span>{t('cash_discount')}</span>
          </div>
          <div className="description bold">{t('exclusive_offer')}</div>
        </div>
      );
    }

    return (
      <h3 className="offer-content">
        <div className="percentage-payment">
          <span>{offer?.downPaymentPercentage}% </span>
          <span>{t('downpayment')} </span>
        </div>
        <div className="installment-years">
          <span>{offer?.years} </span>
          <span>{t('years')} </span>
        </div>
        <div className="description">{offer.description}</div>
      </h3>
    );
  };

  return (
    <OfferCard>
      <div className="offer-tag">
        <Image
          fill
          alt="Offer Tag"
          src={`/assets/icons/entity/offer-tag-${locale}.svg`}
        />
      </div>
      {getCardContent()}
    </OfferCard>
  );
};

const OfferCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 130px;
  min-width: 130px;
  height: 151px;
  background: rgba(235, 158, 72, 0.1);
  border-radius: 8px;

  .offer-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-align: center;
    padding: 16px;

    .percentage-payment {
      display: flex;
      flex-direction: column;
      align-items: center;

      span {
        &:first-child {
          font-family: materialBold;
          font-size: ${props => props.theme.font.sizes.xxxxl};
          color: #eb9e48;
          margin-bottom: 4px;
        }

        &:last-child {
          font-family: materialRegular;
          font-size: 10px;
          color: ${props => props.theme.light.colors.black};
        }
      }
    }
  }

  .installment-years {
    display: flex;
    align-items: center;
    gap: 4px;
    font-family: materialBold;
    font-size: ${props => props.theme.font.sizes.s};
    color: ${props => props.theme.light.colors.black};
  }

  .description {
    font-family: materialRegular;
    font-size: ${props => props.theme.font.sizes.xxs};
    color: ${props => props.theme.light.colors.black};

    &.bold {
      font-family: materialBold;
    }
  }

  .offer-tag {
    position: absolute;
    top: 0px;
    inset-inline-start: 0px;
    width: 63px;
    height: 48px;
  }
`;

export default OfferPlan;
